import { render, staticRenderFns } from "./community-partners.vue?vue&type=template&id=2665ac1c&scoped=true&"
import script from "./community-partners.vue?vue&type=script&lang=js&"
export * from "./community-partners.vue?vue&type=script&lang=js&"
import style0 from "./community-partners.vue?vue&type=style&index=0&id=2665ac1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2665ac1c",
  null
  
)

export default component.exports